export class AppRoutingRouteNames {
    public static readonly SignIn = 'signin';
    public static readonly Dashboard = 'dashboard';
    public static readonly Error = 'error';
    public static readonly UnAuthorized = 'unauthorized';
    public static readonly NotFound = 'not-found';
    public static readonly EmailLink = 'email-link';
    public static readonly EmailLinkParamName = 'emailLink';
    public static readonly Startup = 'startup';
    public static readonly AppUpdateInfo = 'app-update-info';
    public static readonly NonActiveVetError = 'non-active-vet-error';
    public static readonly UserIdParamName = 'UserId';
    public static readonly InvoiceIdParamName = 'InvoiceId';
    public static readonly PaymentSuccessfulParamName = 'Success';
    public static readonly NewHealthRecord = 'new-external-health-record';
    public static readonly InvalidEmailLink = 'invalid-email-link';
    public static readonly UnregisteredDataObjection = 'unregistered-data-objection';
}
